import axios from "axios";

const baseURl = "https://synapsify.synapsivate.com";

export const findMyUrl = async (email) => {
  let res = await axios.get(`${baseURl}/api/find-my-url`, {
    params: { email },
  });
  return res;
};

export const register_new_company = async (data) => {
  let res = await axios.post(`${baseURl}/api/su/regcompany`, data);
  return res;
};

export const contact_Us = async (data) => {
  let res = await axios.post(`${baseURl}/api/contact-us`, data, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res;
};

export const subscribeNewsletter = async (email) => {
  const data = { email };
  let res = await axios.post(`${baseURl}/api/subscribe-newsletter`, data, {
    headers: { "Content-Type": "Application/json" },
  });
  return res;
};
